<template>
<div class="d-flex flex-column" id="app" :class="{'dark-mode': darkMode}">
  <main class="flex-fill">
    <transition name="fade">
      <login v-if="isLogin" @goToRegister="showRegister" @goToForgot="showForgot" @closeLogin="close"></login>
      <forgot v-if="isForgot" @goToLogin="showLogin" @closeForgot="close"></forgot>
      <register v-if="isRegister" @goToLogin="showLogin" @closeRegister="close"></register>
    </transition>
    <app-header :position="isScrolled" :class="{'navbar-light': !darkMode, 'navbar-dark': darkMode}" @toggleMode="darkMode = !darkMode" @goToLogin="showLogin" @goToRegister="showRegister" :currentPage="currentRouteName" v-if="landing"></app-header>
    <store-header :position="isScrolled" :class="{'navbar-light': !darkMode, 'navbar-dark': darkMode}" @toggleMode="darkMode = !darkMode" @goToLogin="showLogin" @goToRegister="showRegister" :currentPage="currentRouteName" v-else></store-header>
    <message-component></message-component>
    <div class="row mb-4 mx-0 justify-content-center">
      <div class="col-md-10 offset-md-1 col-12 p-0 px-md-3">
        <router-view v-on:login='isLogin = true' :position="isScrolled"></router-view>
      </div>
    </div>
    <landing-footer v-if="landing"></landing-footer>
  </main>
<!--
    <footer class="navbar-default navbar-bottom navbar-dark bg-dark">
      <div class="container-fluid">
            <p class="text-center nav-bar mb-0">Checkout repository at <a href="https://github.com/ittus/vuejs-firebase-shopping-cart" target="_blank">
              https://github.com/ittus/vuejs-firebase-shopping-cart
            </a></p>
      </div>
    </footer> -->
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import MessageComponent from './components/common/MessageComponent.vue'
export default {
  components: {
    MessageComponent,
    'login': () => import('@/views/Login.vue'),
    'register': () => import('@/views/Register.vue'),
    'forgot': () => import('@/views/ForgotPassword.vue'),
    'app-header': () => import('@/components/landing/Header.vue'),
    'store-header': () => import('@/components/Header.vue'),
    'landing-footer': () => import('@/components/Footer.vue')
  },
  data () {
    return {
      darkMode: false,
      isScrolled: 'top',
      isLogin: false,
      isRegister: false,
      isForgot: false
    }
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    landing () {
      return this.$route.path === '/' | this.$route.path === '/landing'
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions(['getShoppingCart', 'listenToCategoryList', 'getShopDetails', 'listenToStoreList']),
    handleScroll () {
      if (window.scrollY > 10) {
        this.isScrolled = 'scrolled'
      } else {
        this.isScrolled = 'top'
      }
    },
    showLogin () {
      this.isRegister = false
      this.isLogin = true
      this.isForgot = false
    },
    showRegister () {
      this.isRegister = true
      this.isLogin = false
      this.isForgot = false
    },
    showForgot () {
      this.isForgot = true
      this.isRegister = false
      this.isLogin = false
    },
    close () {
      this.isRegister = false
      this.isLogin = false
      this.isForgot = false
    }
  }
}
</script>

<style>
#app {
  background-color: var(--light-color-off);
  min-height: 100vh;
  font-weight: 400;
  color: var(--dark-color);
}
#app.dark-mode  {
  background-color: var(--dark-color);
  color: var(--light-color);
  font-weight: 300;
}
#reset-store-panel {
  position: fixed; bottom: 0px; right: 0px;
}

body, .sticky-footer-wrapper {
    min-height:100vh;
}

.flex-fill {
    flex:1 1 auto;
}
footer {
  height: 40px;
  color: #666;
  padding: 10px 0 10px 0;
  font-size: 85%;
}
footer a {
  color: #999;
}
footer a:hover {
  color: #efefef;
}
@media (max-width: 576px) {
  footer {
    height: 50px;
  }
}
</style>
